// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1XUQO","productName":"Table_productName__3gpnV"};